import { FC } from 'react';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { Divider, Stack } from '@servicetitan/design-system';
import { DetailsItem } from '../details-item/details-item';
import { DetailsSection } from '../details-item/details-section';
import { tenantStatusProps } from '../../utils/tenant-status-props';
import { ManageTenantStore } from '../../stores/manage-tenant.store';

export const TenantPanelContent: FC = observer(() => {
    const [{ partnerGenericConfigs, tenant }] = useDependencies(ManageTenantStore);

    const partnerConfigs = tenant?.partnerDetail.configs;

    return (
        <Stack direction="column" className="w-100">
            <DetailsSection title="Tenant Details">
                <Stack direction="column" spacing={2}>
                    <DetailsItem
                        name="Tenant Name"
                        value={tenant?.displayName}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Tenant ID"
                        value={tenant?.externalId}
                        textClassName="skeleton-text-33"
                    />
                    <DetailsItem
                        name="Parent Name"
                        value={tenant?.partnerId}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Parent ID"
                        value={tenant?.partnerId}
                        textClassName="skeleton-text-33"
                    />
                    <DetailsItem
                        name="Status"
                        value={tenant ? tenantStatusProps[tenant.status].displayName : undefined}
                        textClassName="skeleton-text-33"
                    />
                </Stack>
            </DetailsSection>
            <Divider spacing={3} />
            <DetailsSection title="Inherited values from Partner">
                <Stack direction="column" spacing={2}>
                    <DetailsItem
                        name="Email Sender Domain"
                        value={partnerConfigs?.emailSenderDomain}
                        textClassName="skeleton-text-75"
                    />
                    <DetailsItem
                        name="Email Scope"
                        value={partnerConfigs?.emailScope}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Direct Mail Provider"
                        value={partnerConfigs?.directMailProvider}
                        textClassName="skeleton-text-50"
                    />
                    {partnerConfigs?.isPartnerLevelAuth === true && (
                        <DetailsItem
                            name="Auth Path URL"
                            value={partnerConfigs?.authPath}
                            textClassName="skeleton-text-75"
                        />
                    )}
                    <DetailsItem
                        name="Knowledge Base URL"
                        value={partnerConfigs?.partnerKBUrl}
                        textClassName="skeleton-text-75"
                    />
                    <DetailsItem
                        name="Email Template Opt In/Out"
                        value={partnerConfigs?.emailTemplateOptOut ? 'Opt Out' : 'Opt In'}
                        textClassName="skeleton-text-75"
                    />
                    {[...partnerGenericConfigs].map(entry => (
                        <DetailsItem
                            key={entry[0]}
                            name={entry[0]}
                            value={entry[1]}
                            textClassName="skeleton-text-75"
                        />
                    ))}
                </Stack>
            </DetailsSection>
        </Stack>
    );
});
